import { buildRegistrationData } from "./buildRegistrationData";
import { registrationTemplate } from "./registrationTemplate";
import { exportToPdf } from "./exportToPdf";

export const generateRegistrationPdf = ({
  methods,
  voucherValid,
  calculateSchedulePricing,
  formatCitiesForPDF,
}) => {
  const data = buildRegistrationData({
    methods,
    voucherValid,
    calculateSchedulePricing,
  });

  const html = registrationTemplate({
    ...data,
    voucherValid,
    formatCitiesForPDF,
  });

  const fileName = `NIEC_Registration_${data.formData.fullName || "Document"}.pdf`;

  return exportToPdf({ html, fileName });
};